import { SupplierBase } from '@retail/suppliers/types';
import { SupplierItemAssortmentTagDTO, SupplierItemWithTagsDTO } from '../../dto';
import { dateFromString } from '@retail/utils';

export interface SupplierItemWithAssortmentTagsProps {
  mgSupplierItemId: number;
  supplier: SupplierBase;
  inAssortment: boolean;
  inAssortmentFrom?: Date;
  inAssortmentTo?: Date;
  tags: SupplierItemAssortmentTag[];
}

export class SupplierItemWithAssortmentTags {
  mgSupplierItemId: number;
  supplier: SupplierBase;
  inAssortment: boolean;
  inAssortmentFrom?: Date;
  inAssortmentTo?: Date;
  tags: SupplierItemAssortmentTag[];

  constructor({
    mgSupplierItemId,
    supplier,
    inAssortment,
    inAssortmentFrom,
    inAssortmentTo,
    tags,
  }: SupplierItemWithAssortmentTagsProps) {
    this.mgSupplierItemId = mgSupplierItemId;
    this.supplier = supplier;
    this.inAssortment = inAssortment;
    this.inAssortmentFrom = inAssortmentFrom;
    this.inAssortmentTo = inAssortmentTo;
    this.tags = tags;
  }

  static fromDto = ({
    mgSupplierItemId,
    supplier,
    inAssortment,
    inAssortmentFrom,
    inAssortmentTo,
    tags,
  }: SupplierItemWithTagsDTO): SupplierItemWithAssortmentTags => {
    return new SupplierItemWithAssortmentTags({
      mgSupplierItemId,
      supplier: SupplierBase.fromDto(supplier),
      inAssortment,
      inAssortmentFrom: dateFromString(inAssortmentFrom),
      inAssortmentTo: dateFromString(inAssortmentTo),
      tags: tags.map(SupplierItemAssortmentTag.fromDto),
    });
  };
}

export interface SupplierItemAssortmentTagProps {
  id?: number;
  tagId: number;
  tagName?: string;
  validFrom: Date;
  validTo?: Date;
}

export class SupplierItemAssortmentTag {
  id?: number;
  tagId: number;
  tagName?: string;
  validFrom: Date;
  validTo?: Date;

  constructor({ id, tagId, tagName, validFrom, validTo }: SupplierItemAssortmentTagProps) {
    this.id = id;
    this.tagId = tagId;
    this.tagName = tagName;
    this.validFrom = validFrom;
    this.validTo = validTo;
  }

  static fromDto = ({
    id,
    tagId,
    tagName,
    validFrom,
    validTo,
  }: SupplierItemAssortmentTagDTO): SupplierItemAssortmentTag => {
    return new SupplierItemAssortmentTag({
      id,
      tagId,
      tagName,
      validFrom: new Date(validFrom),
      validTo: validTo ? new Date(validTo) : undefined,
    });
  };
}
